export enum BuildingStatus {
  Unfinished = 'unfinished',
  Finished = 'finished',
}

export enum BuildingType {
  New = 'newBuilding',
  Panel = 'prefab',
  Brick = 'brick',
  Merchant = 'merchant',
}

export enum BuildingAge {
  Under15 = 'under15',
}

export enum BuildingReconstruction {
  Without = 'without',
  Completed = 'complete',
  Partial = 'partial',
}
